import { useEffect, useState } from 'react';
import { articles, type ArticleItem } from '@/mocks/yokaiManga';

export default function Articles() {
  const [active, setActive] = useState<ArticleItem | null>(null);

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [active]);

  return (
    <section id="articles" className="bg-paper-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-2 md:mb-12">
          <p className="text-sm font-medium text-primary-600">编辑精选</p>
          <h2 className="font-serif text-2xl font-bold text-ink-900 md:text-3xl">精选阅读</h2>
          <p className="max-w-2xl text-sm text-ink-500 md:text-base">
            关于狐妖漫画的演变、花妖漫画的中式美学、新手入坑指南……
            用有深度的内容陪你更好地读懂妖精漫画。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {articles.map((article) => (
            <article
              key={article.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper-200 bg-paper-50 transition-all hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-paper-50/90 px-3 py-1 text-xs font-medium text-primary-600">
                  {article.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-serif text-base font-bold leading-snug text-ink-900">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-ink-500 md:text-sm">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-paper-200 pt-3">
                  <span className="text-xs text-ink-400">
                    {article.date} · {article.read}
                  </span>
                  <button
                    type="button"
                    onClick={() => setActive(article)}
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* 阅读弹窗 */}
      {active && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-ink-900/60 p-4 backdrop-blur-sm"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
          aria-label={active.title}
        >
          <div
            className="max-h-[85vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-paper-50"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-paper-200 bg-paper-50 px-5 py-4 md:px-8">
              <span className="rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-600">
                {active.category}
              </span>
              <button
                type="button"
                onClick={() => setActive(null)}
                className="flex h-9 w-9 items-center justify-center rounded-lg text-ink-600 transition-colors hover:bg-paper-200"
                aria-label="关闭阅读窗口"
              >
                <i className="ri-close-line text-xl" aria-hidden="true"></i>
              </button>
            </div>
            <div className="px-5 py-6 md:px-8 md:py-8">
              <h3 className="font-serif text-xl font-bold text-ink-900 md:text-2xl">{active.title}</h3>
              <p className="mt-2 text-xs text-ink-400">
                {active.date} · {active.read} 阅读 · 妖精漫画大全
              </p>
              <div className="mt-5 flex flex-col gap-4">
                {active.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm leading-7 text-ink-700 md:text-base">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}